import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Home from './pages/Home';
import Workout from './pages/Workout';
import Progress from './pages/Progress';
import Schedule from './pages/Schedule';
import Exercises from './pages/Exercises';
import Settings from './pages/Settings';
import WeeklyPlanner from './pages/WeeklyPlanner';
import WeeklyCheckIn from './pages/WeeklyCheckIn';
import WeeklyReview from './pages/WeeklyReview';
import NutritionTracker from './pages/NutritionTracker';
import ApiTest from './pages/ApiTest';
import UserSelect from './pages/UserSelect';
import Onboarding from './pages/Onboarding';
import InstallPrompt from './components/InstallPrompt';
import ScrollToTop from './components/ScrollToTop';
import { ToastProvider } from './components/Toast';
import './App.css';

function App() {
  const [currentUser, setCurrentUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const user = localStorage.getItem('currentUser');
    console.log('App.js: Current user on load:', user);
    setCurrentUser(user);
    setLoading(false);

    // Listen for storage changes (when user is selected)
    const handleStorageChange = () => {
      const updatedUser = localStorage.getItem('currentUser');
      console.log('App.js: User changed to:', updatedUser);
      setCurrentUser(updatedUser);
    };

    window.addEventListener('storage', handleStorageChange);

    // Also check periodically in case storage event doesn't fire
    const interval = setInterval(() => {
      const updatedUser = localStorage.getItem('currentUser');
      if (updatedUser !== currentUser) {
        console.log('App.js: User updated via polling:', updatedUser);
        setCurrentUser(updatedUser);
      }
    }, 500);

    return () => {
      window.removeEventListener('storage', handleStorageChange);
      clearInterval(interval);
    };
  }, [currentUser]);

  if (loading) {
    return <div className="App">Loading...</div>;
  }

  return (
    <ToastProvider>
      <Router>
        <ScrollToTop />
        <div className="App">
          <InstallPrompt />
          <Routes>
            <Route path="/user-select" element={<UserSelect />} />
            <Route path="/onboarding" element={<Onboarding />} />
            <Route path="/api-test" element={<ApiTest />} />

            {/* Protected routes - require user */}
            <Route path="/" element={currentUser ? <Home /> : <Navigate to="/user-select" />} />
            <Route path="/workout" element={currentUser ? <Workout /> : <Navigate to="/user-select" />} />
            <Route path="/progress" element={currentUser ? <Progress /> : <Navigate to="/user-select" />} />
            <Route path="/schedule" element={currentUser ? <Schedule /> : <Navigate to="/user-select" />} />
            <Route path="/exercises" element={currentUser ? <Exercises /> : <Navigate to="/user-select" />} />
            <Route path="/settings" element={currentUser ? <Settings /> : <Navigate to="/user-select" />} />
            <Route path="/weekly-planner" element={currentUser ? <WeeklyPlanner /> : <Navigate to="/user-select" />} />
            <Route path="/weekly-check-in" element={currentUser ? <WeeklyCheckIn /> : <Navigate to="/user-select" />} />
            <Route path="/weekly-review" element={currentUser ? <WeeklyReview /> : <Navigate to="/user-select" />} />
            <Route path="/nutrition" element={currentUser ? <NutritionTracker /> : <Navigate to="/user-select" />} />
          </Routes>
        </div>
      </Router>
    </ToastProvider>
  );
}

export default App;
